module.exports = {
  dish1: {
    name: "Chicken 1",
    description: "Insert Chicken 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Chicken 2",
    description: "Insert Chicken 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Chicken 3",
    description: "Insert Chicken 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Chicken 4",
    description: "Insert Chicken 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Chicken 5",
    description: "Insert Chicken 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Chicken 6",
    description: "Insert Chicken 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Chicken 7",
    description: "Insert Chicken 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Chicken 8",
    price: 4400,
    description: "Insert Chicken 8 description",
    status: "available"
  },
  dish9: {
    name: "Chicken 9",
    price: 3300,
    description: "Insert Chicken 9 description",
    status: "available"
  },
  dish10: {
    name: "Chicken 10",
    price: 3900,
    description: "Insert Chicken 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/ThreeFeathersDiner.js